import { registerRoot } from "remotion";
// import TikTokVideo from "./TikTokVideo";
import TikTokVideoVanilla from "./TikTokVideoVanilla";
registerRoot(TikTokVideoVanilla);
